import RegisterPage from "@/components/Register/RegisterPage.vue";
import RegisterStepConfirm from "@/components/Register/RegisterStepConfirm.vue";
import RegisterStepConfirmSecure from "@/components/Register/RegisterStepConfirmSecure.vue";
import RegisterStepPassword from "@/components/Register/RegisterStepPassword.vue";
import RegisterStepUserName from "@/components/Register/RegisterStepUserName.vue";
import RegisterStepAccountInfo from "@/components/Register/RegisterStepAccountInfo.vue";
import RegisterStepSelectSecureMethod from "@/components/Register/RegisterStepSelectSecureMethod.vue";

export default [
    {
        path: "/register",
        component: RegisterPage,
        meta: { layout: "default", title: 'Đăng ký' },
        name: "register",
        children: [
            {
                path: "",
                component: RegisterStepUserName,
                name: "regdefault",
            },
            {
                path: "username",
                component: RegisterStepUserName,
                name: "regusername",
            },
            {
                path: "info",
                component: RegisterStepAccountInfo,
                name: "regaccountinfo",
            },
            {
                path: "password",
                component: RegisterStepPassword,
                name: "regpassword",
            },
            {
                path: "confirm",
                component: RegisterStepConfirm,
                name: "regconfirm",
            },
            {
                path: "confirmsecure",
                component: RegisterStepConfirmSecure,
                name: "regconfirmsecure",
            },
            {
                path: "selectsecure",
                component: RegisterStepSelectSecureMethod,
                name: "regselectsecure",
            },
        ],
    }
];
